module.exports = __webpack_public_path__ + "img/Kefalonia.74d3af92.png";